import React, { useState, useEffect } from "react";
import axios from "axios";
import SellerLayout from "./SellerLayout";
import "./SellerDashboard.css";
import { image } from "./image";
import Barcode from "react-barcode";
import { useQuery } from "@tanstack/react-query";

const unitOptions = ["Gm", "Kg", "Ltr", "Pcs"];
const SellerAddProduct = () => {
  const [files, setFiles] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [Category, setCategory] = useState("");
  const [Subcategory, setSubcategory] = useState("");
  const [Variant, setVariant] = useState("");
  const [Brand, setBrand] = useState("");
  const [price, setPrice] = useState("");
  const [offerPrice, setOfferPrice] = useState("");
  const [unit, setUnit] = useState("");
  const [stock, setStock] = useState("");
  const [quantity, setQuantity] = useState("");
  const [tax, setTax] = useState("");
 const [unitValue, setUnitValue] = useState("");   // for the numeric value you type
const [unitType, setUnitType] = useState("Kg");   // for the dropdown unit (default Kg)
const [showDropdown, setShowDropdown] = useState(false);


  const [barcodeOption, setBarcodeOption] = useState("manual");
  const [barcode, setBarcode] = useState("");
  const [isPending, setIsPending] = useState(false);

  const [subcategories, setSubcategories] = useState([]);
  const [variants, setVariants] = useState([]);

  // ✅ Fetch Categories
  const { data: categoryData, isLoading: categoryLoading } = useQuery({
    queryKey: ["categoryData"],
    queryFn: async () => {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/admindata/getCategory`);
      return res.data.categories || res.data;
    },
  });

  // ✅ Fetch Brands
  const { data: brandData, isLoading: brandLoading } = useQuery({
    queryKey: ["brandData"],
    queryFn: async () => {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/brand`);
      return res.data.brands;
    },
  });

  // ✅ Fetch Subcategories based on Category
  useEffect(() => {
    if (!Category) {
      setSubcategories([]);
      setSubcategory("");
      return;
    }
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/subcategory/byCategory/${Category}`)
      .then((res) => {
        if (res.data.success) setSubcategories(res.data.subCategories);
        else setSubcategories([]);
      })
      .catch((err) => console.error("Error fetching subcategories:", err));
  }, [Category]);

  // ✅ Fetch Variants based on Subcategory
  useEffect(() => {
    if (!Subcategory) {
      setVariants([]);
      setVariant("");
      return;
    }

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/variant/bySubCategory/${Subcategory}`)
      .then((res) => {
        console.log("Variant API response:", res.data);
        if (res.data.success && Array.isArray(res.data.variants)) {
          setVariants(res.data.variants);
        } else if (Array.isArray(res.data)) {
          // if backend returns direct array (no "variants" wrapper)
          setVariants(res.data);
        } else {
          setVariants([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching variants:", err);
        setVariants([]);
      });
  }, [Subcategory]);

  //  Generate Barcode
  const generateBarcode = () => "BC" + Date.now() + Math.floor(1000 + Math.random() * 9000);

  // ✅ Handle Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsPending(true);

    try {
      let finalBarcode = barcode;
      if (barcodeOption === "auto" && !barcode) {
        finalBarcode = generateBarcode();
        setBarcode(finalBarcode);
      }

      const productData = {
        name,
        description: description.split("\n"),
        price,
        offerPrice,
        quantity,   
        unit,       
        stock,
        tax,        
        brand: Brand,
        category: Category,
        subcategory: Subcategory,
        variant: Variant,
        barcode: finalBarcode,
      };
      

      const formData = new FormData();
      formData.append("productData", JSON.stringify(productData));
      files.forEach((file) => formData.append("images", file));

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/product/add`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          withCredentials: true,
        }
      );

      alert(res.data.message);
      if (res.data.success) {
        setName("");
        setDescription("");
        setPrice("");
        setOfferPrice("");
        setUnit("");
        setStock("");
        setFiles([]);
        setCategory("");
        setSubcategory("");
        setVariant("");
        setBrand("");
        setBarcode("");
        setBarcodeOption("manual");
      }
    } catch (error) {
      console.error("Error adding product:", error.message);
    } finally {
      setIsPending(false);
    }
  };

  return (
    <SellerLayout page="add-product">
      <div className="card product-card">
        <h4>Add New Product</h4>
        <form onSubmit={handleSubmit}>
          {/* Upload Images */}
          <div className="form-group">
            <label>Product Images</label>
            <div className="image-upload-container">
              {Array(1)
                .fill("")
                .map((_, index) => (
                  <label key={index} className="image-upload-label">
                    <input
                      type="file"
                      hidden
                      onChange={(e) => {
                        const updated = [...files];
                        updated[index] = e.target.files[0];
                        setFiles(updated);
                      }}
                    />
                    <img
                      src={
                        files[index]
                          ? URL.createObjectURL(files[index])
                          : image.upload_area
                      }
                      alt="upload"
                      className="image-preview"
                    />
                  </label>
                ))}
            </div>
          </div>

          {/* Product Name + Brand */}
          <div className="form-row">
            <input
              type="text"
              className="form-input"
              placeholder="Product Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <select
              className="form-select"
              value={Brand}
              onChange={(e) => setBrand(e.target.value)}
              required
            >
              <option value="">-- Select Brand --</option>
              {!brandLoading &&
                brandData?.map((b) => (
                  <option key={b._id} value={b._id}>
                    {b.name}
                  </option>
                ))}
            </select>
          </div>

          {/* Category + Subcategory */}
          <div className="form-row mt-2">
            <select
              className="form-select"
              value={Category}
              onChange={(e) => setCategory(e.target.value)}
              required
            >
              <option value="">-- Select Category --</option>
              {!categoryLoading &&
                categoryData?.map((c) => (
                  <option key={c._id} value={c._id}>
                    {c.name}
                  </option>
                ))}
            </select>

            <select
              className="form-select"
              value={Subcategory}
              onChange={(e) => setSubcategory(e.target.value)}
              required
              disabled={!Category}
            >
              <option value="">-- Select Subcategory --</option>
              {subcategories.map((s) => (
                <option key={s._id} value={s._id}>
                  {s.name}
                </option>
              ))}
            </select>
          </div>

          {/* ✅ Variant Dropdown */}
          {Subcategory && (
            <div className="form-group mt-2">
              <select
                className="form-select"
                value={Variant}
                onChange={(e) => setVariant(e.target.value)}
                required
                disabled={variants.length === 0}
              >
                <option value="">
                  {variants.length === 0
                    ? "-- No Variants Found --"
                    : "-- Select Variant --"}
                </option>
                {variants.map((v) => (
                  <option key={v._id} value={v._id}>
                    {v.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Description */}
          <textarea
            className="form-textarea mt-2"
            rows={4}
            placeholder="Product Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />

          {/* Price + Offer */}
          <div className="form-row mt-2">
            <input
              type="number"
              className="form-input"
              placeholder="Price"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              required
            />
            <input
              type="number"
              className="form-input"
              placeholder="Offer Price"
              value={offerPrice}
              onChange={(e) => setOfferPrice(e.target.value)}
            />
          </div>


  {/* Quantity + Unit + Stock */}
<div className="form-row mt-2">
  {/* Quantity field */}
  <input
    type="number"
    className="form-input"
    placeholder="Quantity"
    value={quantity}
    onChange={(e) => setQuantity(e.target.value)}
    required
  />

  {/* Unit field as dropdown */}
  <select
    className="form-input"
    value={unit}
    onChange={(e) => setUnit(e.target.value)}
    required
  >
    <option value="">Select Unit</option>
    <option value="Gm">Gm</option>
    <option value="Kg">Kg</option>
    <option value="Ltr">Ltr</option>
    <option value="Pcs">Pcs</option>
  </select>

  {/* Stock field */}
  <input
    type="number"
    className="form-input"
    placeholder="Stock"
    value={stock}
    onChange={(e) => setStock(e.target.value)}
    required
  />
</div>


          {/* Tax */}
          <div className="form-row mt-2">
            <input
              type="number"
              className="form-input"
              placeholder="Tax (%)"
              value={tax}
              onChange={(e) => setTax(e.target.value)}
              required
            />
</div>

          {/* Barcode Options */}
          <div className="form-group mt-2">
            <label>Barcode Option</label>
            <div className="form-row">
              <label>
                <input
                  type="radio"
                  value="manual"
                  checked={barcodeOption === "manual"}
                  onChange={(e) => setBarcodeOption(e.target.value)}
                />
                Manual
              </label>
              <label style={{ marginLeft: "20px" }}>
                <input
                  type="radio"
                  value="auto"
                  checked={barcodeOption === "auto"}
                  onChange={(e) => {
                    setBarcodeOption(e.target.value);
                    setBarcode(generateBarcode());
                  }}
                />
                Auto Generate
              </label>
            </div>
          </div>

          {barcodeOption === "manual" && (
            <input
              type="text"
              className="form-input mt-1"
              placeholder="Enter Barcode"
              value={barcode}
              onChange={(e) => setBarcode(e.target.value)}
            />
          )}

          {barcode && (
            <div className="mt-2 text-center" id="barcode">
              <Barcode value={barcode} />
            </div>
          )}

          <button type="submit" className="btn btn-primary w-100 mt-4" disabled={isPending}>
            {isPending ? "Adding..." : "Add Product"}
          </button>
        </form>
      </div>
    </SellerLayout>
  );
};

export default SellerAddProduct;
